module.exports = __webpack_public_path__ + "static/media/Step 02.0435cbd4.png";